export default __webpack_public_path__ + "static/media/category1.f58f5127.svg";